<div class="loading">
  Loading
  <p-progressSpinner strokeWidth="4" animationDuration=".5s" />
</div>
